import {
  mdiClock,
  mdiAccountPlus,
  mdiCalendarPlus,
  mdiNoteOutline,
  mdiNoteMinusOutline,
  mdiNotePlusOutline,
  mdiHistory,
  mdiEye,
  mdiTimeline,
  mdiFormatListBulleted,
  mdiSortNumericDescending,
  mdiSortNumericAscending,
  mdiPencil,
  mdiPlus,
  mdiSync,
  mdiDelete,
  mdiDeleteRestore,
  mdiArrowUp,
  mdiArrowDown
} from '@mdi/js'

export default {
  'freshvuehistory-duration': mdiClock,
  'freshvuehistory-created-by': mdiAccountPlus,
  'freshvuehistory-created-at': mdiCalendarPlus,
  'freshvuehistory-description': mdiNoteOutline,
  'freshvuehistory-arrowup': mdiArrowUp,
  'freshvuehistory-arrowdown': mdiArrowDown,
  'freshvuehistory-show-history': mdiHistory,
  'freshvuehistory-action-show': mdiEye,
  'freshvuehistory-view-timeline': mdiTimeline,
  'freshvuehistory-view-table': mdiFormatListBulleted,
  'freshvuehistory-order-desc': mdiSortNumericDescending,
  'freshvuehistory-order-asc': mdiSortNumericAscending,
  'freshvuehistory-filter-EDIT': mdiPencil,
  'freshvuehistory-filter-NOTE': mdiNoteOutline,
  'freshvuehistory-event-CREATED': mdiPlus,
  'freshvuehistory-event-UPDATED': mdiSync,
  'freshvuehistory-event-DELETED': mdiDelete,
  'freshvuehistory-event-RESTORED': mdiDeleteRestore,
  'freshvuehistory-event-NOTE_CREATED': mdiNotePlusOutline,
  'freshvuehistory-event-NOTE_DELETED': mdiNoteMinusOutline
}
